import { useTranslation } from 'react-i18next';
import { useToastStore } from '@stores/toastStore';
import { copyText } from '@utils/clipboard';

/**
 * 独立部署期间：分享按钮直接复制当前页面地址。
 */
export function useShareAction() {
  const { t } = useTranslation();

  return () => {
    void copyText(window.location.href).then((result) => {
      const message = result.ok
        ? t('share.link-copied')
        : result.reason === 'permission-denied'
          ? t('share.copy-permission-denied')
          : t('share.copy-failed');
      useToastStore.getState().addToast(message, result.ok ? 'success' : 'error');
    });
  };
}
